<template>
	<div>
		<v-badge
		bordered
		color="primary"
		:content="filter_count"
		overlap
		v-if="filter_count>0"
		>
		<v-btn  rounded depressed  outlined  class="download-svg-btn" width="85">
			<v-icon>mdi-filter</v-icon>
			{{$lang.FILTER}}
		</v-btn>
	</v-badge>

	
	<v-btn v-if="filter_count<1" rounded depressed  outlined  class="download-svg-btn" width="85">
		<v-icon>mdi-filter</v-icon>
		{{$lang.FILTER}}
	</v-btn>


</div>
</template>

<script  type="text/javascript">
export default{
	props:{
		filter_count:{
			default: 0,
		}
	}
}


</script>